/* unplugin-vue-components disabled */
import {Tree} from 'primevue'

export default {
  components: {Tree},

  props: {
    rootName: {type: String, default: 'root'},
    object: {type: Object, required: true} 
  },

  computed: {
    nodes() {
      return [this.toNode(this.rootName, this.object)]
    }
  },

  methods: {
    toNode(key, value) {
      const node = {
        key,
        label: key,
        children: null,
        data: null
      }

      if (value !== null && typeof value === 'object') {
        // object / array
        const entries = Object.entries(value)

        node.children = entries.map(([k, v]) => this.toNode(k, v))

        if (Array.isArray(value)) {
          node.data = `Array (${entries.length})`
        } else {
          node.data = 'Object'
        }
        return node
      }

      // --- primitive types ---
      node.leaf = true

      if (typeof value === 'string') {
        const str = $utils.str.escapeRawString(value)
        if (Date.parse(str)) {
          node.data = str
          node.is_date = true
        } else {
          node.data = `"${str}"`
          node.is_str = true
        }
        return node
      }

      if (typeof value === 'number') {
        node.data = value
        node.is_num = true
        return node
      }

      if (typeof value === 'boolean') {
        node.data = value ? 'true' : 'false'
        node.is_bool = true
        return node
      }

      if (value === null) {
        node.data = 'null'
        node.is_null = true
        return node
      }

      node.data = String(value)
      return node
    }
  }
}
